/**
 * AI Briefing Lesson
 * Skill Area: Communication
 * Teach AI your organizational voice
 */

import type { LessonDefinition } from '../types';
import { AI_BRIEFING_AI_PROMPT, AI_BRIEFING_CONTEXT_SCENARIOS } from '../prompts/ai-briefing.prompt';

export const aiBriefing: LessonDefinition = {
  id: 'ai-briefing',
  title: 'AI Briefing',
  displayTitle: 'Teach AI Your Organizational Voice',
  subTitle: 'Teach AI your organizational voice',
  persona: 'Lyra',
  skillArea: 'Communication',
  topicId: 'communication-quality',
  topicTitle: 'Communication Quality & Voice',
  topicDescription: 'Verify outputs, keep your voice authentic, and build reusable comms systems.',
  format: 'tool_lab',
  difficulty: 'Beginner',
  estimatedMinutes: 10,
  tags: ['briefing', 'voice', 'persona'],
  dailyEligible: true,
  releasedAt: '2025-01-16T00:00:00.000Z',
  route: '/micro/ai-briefing',
  storyBeat: 'Capture your unique voice so AI sounds like you.',
  introPrompt: "AI doesn't know your voice unless you teach it. Every output sounds generic because it's missing context only you can provide.",
  steps: [
    "Share a sample of content that represents your voice",
    "See the three elements that capture organizational voice",
    "Build your Voice Brief through v1 → v2 → v3 refinement",
    "Master the briefing pattern for any future AI work"
  ],
  promptGuidance: 'Share a sample that shows your voice, or describe your communication style.',
  contextScenarios: AI_BRIEFING_CONTEXT_SCENARIOS,
  aiPrompt: AI_BRIEFING_AI_PROMPT,
  inputPlaceholder: "Share a sample of your writing or describe your communication style...",
  quickPrompts: [
    'Donor communications',
    'Program updates',
    'Social media posts',
    'Board communications'
  ]
};
